import * as go from 'gojs';
import { sidebarConfig } from '../../config/config';
import { fromPortIdBinding, toPortIdBinding } from './../common/utils/bindings';

const $ = go.GraphObject.make;

export const linkTemplate = () =>
  $(
    go.Link,
    {
      routing: go.Link.Orthogonal,
      adjusting: go.Link.Scale,
      corner: 10,
      relinkableFrom: true,
      relinkableTo: true,
      cursor: 'pointer',
      fromShortLength: 0,
      fromEndSegmentLength: 10,
      toShortLength: 6,
      toEndSegmentLength: 10,
    },
    linkShape(),
    arrowShape(),
    fromPortIdBinding(),
    toPortIdBinding(),
  );

const linkShape = () => $(go.Shape, { strokeWidth: 2, stroke: sidebarConfig.colors.link.color });
const arrowShape = () =>
  $(go.Shape, {
    toArrow: 'Standard',
    fill: sidebarConfig.colors.link.color,
    stroke: sidebarConfig.colors.link.color,
    margin: new go.Margin(10),
  });
